import {useUrlState} from "../../../../../lib/utils.ts";
import {SetURLSearchParams} from "react-router-dom";

export interface CashflowPageState {
    month: string
    flow: 'inflow' | 'outflow'
}

const TIMEFRAME_PARAM = 'tf'
const FLOW_PARAM = 'fl'

function serialize(params: URLSearchParams) {
    if (!(params.get(TIMEFRAME_PARAM) && params.get(FLOW_PARAM)))
        return {
            month: null,
            flow: null,
        }

    if (!(params.get(FLOW_PARAM) !== 'inflow' || params.get(FLOW_PARAM) !== 'outflow'))
        throw new Error('Invalid flow')

    return {
        month: new Date(parseInt(params.get(TIMEFRAME_PARAM))).toISOString(),
        flow: params.get(FLOW_PARAM) as 'inflow' | 'outflow',
    }
}



export function deserializeCashflowPageState(newState: CashflowPageState): URLSearchParams {
    const newQueryParameters: URLSearchParams = new URLSearchParams();
    if (newState === null) {
        return newQueryParameters
    }

    newQueryParameters.set(TIMEFRAME_PARAM, String(new Date(newState.month).getTime()))
    newQueryParameters.set(FLOW_PARAM, newState.flow)
    return newQueryParameters
}

export function useCashflowPageState(params: URLSearchParams, setParams: SetURLSearchParams) {
    return useUrlState<CashflowPageState | null>(params, setParams, serialize, deserializeCashflowPageState)
}
